import { SelectOption } from '@/types/form.type.ts';

export enum CarDamageType {
    A1 = 'A1',
    A2 = 'A2',
    B1 = 'B1',
    B2 = 'B2',
    B3 = 'B3',
    C1 = 'C1',
    C2 = 'C2',
    Z = 'Z',
    D = 'D',
    D1 = 'D1',
}

export function getCarDamageTypeLabel(type: CarDamageType): string {
    switch (type) {
        case CarDamageType.A1:
            return type.valueOf() + ' - Скол (полировка)';
        case CarDamageType.A2:
            return type.valueOf() + ' - Скол (окраска)';
        case CarDamageType.B1:
            return type.valueOf() + ' - Царапина (полировка)';
        case CarDamageType.B2:
            return type.valueOf() + ' - Царапина (окраска)';
        case CarDamageType.B3:
            return type.valueOf() + ' - Царапина (требуется замена)';
        case CarDamageType.C1:
            return type.valueOf() + ' - Вмятина без повреждения ЛКП';
        case CarDamageType.C2:
            return type.valueOf() + ' - Вмятина (ремонт+окраска)';
        case CarDamageType.Z:
            return type.valueOf() + ' - Вмятина (требуется замена)';
        case CarDamageType.D:
            return type.valueOf() + ' - Коррозия';
        case CarDamageType.D1:
            return type.valueOf() + ' - Коррозия (требуется замена)';
    }
}

export function getCarDamageTypeSelectOptions(): SelectOption[] {
    const options: SelectOption[] = [];

    Object.values(CarDamageType).forEach((type: CarDamageType) => {
        options.push({
            label: getCarDamageTypeLabel(type),
            value: type,
        });
    });

    return options;
}
